var _rect, _rect2, _rect3, _ellipse, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignal0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.3252,
    width: 4.67504,
    height: 22,
    rx: 2.33752,
    fill: "#8B8B8B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5498,
    y: 5.17645,
    width: 4.67504,
    height: 16.8235,
    rx: 2.33752,
    fill: "#8B8B8B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.77441,
    y: 10.6765,
    width: 4.67504,
    height: 11.3235,
    rx: 2.33752,
    fill: "#8B8B8B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.33752,
    cy: 19.25,
    rx: 2.33752,
    ry: 2.75,
    fill: "#8B8B8B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.84964,
    height: 1.50124,
    rx: 0.75062,
    transform: "matrix(0.647652 -0.761937 0.647652 0.761937 3.2998 6.95148)",
    fill: "#8B8B8B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.84964,
    height: 1.50124,
    rx: 0.75062,
    transform: "matrix(-0.647652 -0.761937 0.647652 -0.761937 8.38379 8.0954)",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal0);
export default __webpack_public_path__ + "static/media/signal-0.69d30e801fe77aaae8978e4c322ba48c.svg";
export { ForwardRef as ReactComponent };